<template>
  <div>
    <b-notification
      v-for="(error, index) in errors"
      :key="index"
      type="is-danger"
      aria-close-label="Close notification"
      role="alert"
    >
      {{ error.message }}
    </b-notification>
    <div>
      <b-field
        :label="$t('Email')"
        :type="{ 'is-danger': $v.form.username.$anyError }"
      >
        <b-input
          v-model.trim="$v.form.username.$model"
          v-on:keyup.enter.native="signUp"
        />
      </b-field>

      <b-field
        :label="$t('Contraseña')"
        :type="{ 'is-danger': $v.form.password.$anyError }"
      >
        <b-input
          v-model.trim="$v.form.password.$model"
          type="password"
          name="password"
          v-on:keyup.enter.native="signUp"
        />
      </b-field>

      <b-field
        :label="$t('Confirmar contraseña')"
        :type="{ 'is-danger': $v.form.passwordConfirm.$anyError }"
      >
        <b-input
          v-model.trim="$v.form.passwordConfirm.$model"
          v-on:keyup.enter.native="signUp"
          type="password"
          name="password"
        />
      </b-field>

      <div class="field">
        <b-checkbox v-model.trim="$v.form.termsAccept.$model">
          {{ $t('Acepto los términos y condiciones') }}
        </b-checkbox>
      </div>

      <div class="field">
        <b-checkbox>
          {{ $t('Quiero subscribirme a la newsletter') }}
        </b-checkbox>
      </div>

      <b-field position="is-centered">
        <p class="control centered">
          <button
            type="submit"
            :disabled="$v.form.$invalid"
            class="button is-black"
            v-on:click="signUp"
          >
            {{ $t('Enviar') }}
          </button>
        </p>
      </b-field>
    </div>

    <section>
      <b-field>
        <div class="control" style="margin-top: 10px;">
          <p>
            <a v-on:click="goToSignIn" class="customLink">
              {{ $t('¿Ya tienes cuenta? Inicia sesión') }}
            </a>
          </p>
        </div>
      </b-field>
    </section>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify'
import { required, email, sameAs } from 'vuelidate/lib/validators'

export default {
  name: 'signUp',
  props: ['toggle'],
  components: {},
  computed: {},
  data() {
    return {
      formState: 'signUp',
      errors: [],
      form: {
        username: '',
        password: '',
        authCode: '',
        email: '',
        passwordConfirm: '',
        termsAccept: false
      }
    }
  },
  validations: {
    form: {
      username: { required, email },
      password: { required },
      termsAccept: { required },
      passwordConfirm: { required, sameAsPassword: sameAs('password') }
    }
  },
  methods: {
    goToSignIn() {
      this.$router.push({ name: 'sign-in' })
    },
    async signUp() {
      let self = this
      this.form.email = this.form.username
      const { username, password, email } = this.form
      const lang = this.$i18n.locale
      await Auth.signUp({
        username,
        password,
        attributes: {
          email: email,
          'custom:lang': lang,
          'custom:avatar_image': 'default.png'
        }
      })
        .then(function() {
          self.$router.push({
            name: 'confirm',
            query: { email: self.form.email }
          })
        })
        .catch(err => self.errors.push(err))
    }
  }
}
</script>

<style>
.formcontainer {
  display: flex;
  flex-direction: column;
  width: 500px;
  margin: 0 auto;
}
.input {
  margin-bottom: 7px;
  height: 38px;
  border: none;
  outline: none;
  border-bottom: 2px solid #ddd;
  font-size: 20px;
}
</style>
